import { requests } from "../actions";

const asyncSubmissionMiddleware = store => next => action => {
  if (action && requests[action.type]) {
    const actionKey = action.type.slice(0, action.type.lastIndexOf('_'));
    requests[action.type](action.payload)
      .then(
        res => store.dispatch({ type: `${actionKey}_SUCCESS` , payload: {res, initial: action.payload}}),
        errors => {
          store.dispatch({ type: `${actionKey}_FAILURE`, payload: errors });
        }
      );
  }
  return next(action);
};

export default asyncSubmissionMiddleware;
